import React, { FC } from 'react';
import styles from './_styles.module.scss';

const JobsInfoListContainer: FC = ({ children }) => {
  return <div className={styles.jobs_wrapper}>{children}</div>;
};

export default JobsInfoListContainer;
